import api from './api';

const departmentService = {
  // Get paginated departments with filtering
  getDepartments: async (page = 0, size = 10, search = '', campusId = '', facultyId = '') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });

      if (search) params.append('search', search);
      if (campusId) params.append('campusId', campusId.toString());
      if (facultyId) params.append('facultyId', facultyId.toString());

      const response = await api.get(`/admin/departments?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching departments:', error);
      throw error;
    }
  },

  // Get single department by ID
  getDepartment: async (id) => {
    try {
      const response = await api.get(`/admin/departments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching department:', error);
      throw error;
    }
  },

  // Create new department
  createDepartment: async (departmentData) => {
    try {
      const response = await api.post('/admin/departments', departmentData);
      return response.data;
    } catch (error) {
      console.error('Error creating department:', error);
      throw error;
    }
  },

  // Update existing department
  updateDepartment: async (id, departmentData) => {
    try {
      const response = await api.put(`/admin/departments/${id}`, departmentData);
      return response.data;
    } catch (error) {
      console.error('Error updating department:', error);
      throw error;
    }
  },

  // Delete department
  deleteDepartment: async (id) => {
    try {
      const response = await api.delete(`/admin/departments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting department:', error);
      throw error;
    }
  }
};

export default departmentService;